export const ARTICLES = [
  {
    slug: "child-signs",
    tag: "Early Intervention",
    read: "6 min read",
    title: "5 Signs a Child May Benefit from Speech Therapy",
    excerpt:
      "Late talking isn't always 'just a phase.' Here's what therapists look for in the early years — and when to refer.",
    author: "Sameeksha Shetty",
    body: null,
  },
  {
    slug: "classroom-red-flags",
    tag: "Teacher Training",
    read: "4 min read",
    title: "Spotting Speech & Language Red Flags in the Classroom",
    excerpt:
      "The quiet child, the 'distracted' child, the child who 'just won't listen' — what to look for before you refer.",
    author: "Sameeksha Shetty",
    body: null,
  },
  {
    slug: "inschool-therapy-parents",
    tag: "For Parents",
    read: "5 min read",
    title: "How In-School Therapy Works: A Parent's Guide",
    excerpt:
      "What happens after the screening, what sessions look like, and how to read your child's monthly progress report.",
    author: "Sameeksha Shetty",
    body: null,
  },
];
